import { Field, Form, Formik } from 'formik'
import Header from 'components/headers/addLoan'
import AddNewIcon from 'assets/images/loans/managementAddNew.svg'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Num2persian from 'utilities/helper/num2Persian'
import { useState } from 'react'
import { toast } from 'react-toastify'
import useGetCards from 'pages/loans/withDraw/hooks/useGetCards'
import SelectModal from 'components/modals/selectModal'
import WithDrawWalletModal from 'components/modals/withDrawWallets'
import FeeModal from 'components/modals/feeModal'
import CustomDatePicker from 'components/datePicker'
import moment from 'jalali-moment'
import { getOneMonthLater } from 'utilities/helper/getOneMonthLater'
import useSetNewLoans from 'pages/loans/manager/addNew/hooks/useSetNewLoans'
import { Schema } from 'pages/loans/manager/addNew/utilities'
import { NumericFormat } from 'react-number-format'
import {
    accountNumberOf,
    formatAccountNumber,
} from 'components/bankAccountCard'
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
export default function AcceptAddNewManagementLoan({}) {
    const { state } = useLocation()
    const [isOpenReceiver, setIsOpenReceiver] = useState<boolean>(false)
    const [selectedUser, setSelectedUser] = useState<ISelectUser | undefined>(
        state && state?.register
            ? {
                  name: state?.register?.name,
                  id: state?.register?.id,
                  memberId: state?.register?.member_id,
              }
            : undefined
    )
    const [isOpenWalletModal, setIsOpenWalletModal] = useState<boolean>(false)
    const [selectedBankNumber, setSelectedBankNumber] = useState<number>(0)
    const [memberId, setMemberId] = useState<undefined | number>()
    const [isOpenFeeModal, setIsOpenFeeModal] = useState<boolean>(false)
    const [selectedFee, setSelectedFee] = useState<number | undefined>(0)
    const [selectedFeeType, setSelectedFeeType] = useState<string>('percentage')
    const navigate = useNavigate()
    const params = useParams()

    const {
        data,
        isLoading,
        activeAccount,
        activeAccounts,
        otherAccounts,
        handleSelectCard,
        reallySelectedCard,
    } = useGetCards(
        selectedUser?.id,
        selectedUser?.memberId,
        setSelectedBankNumber
    )

    const { mutate } = useSetNewLoans()
    return (
        <>
            <Formik
                initialValues={{
                    amount: state && state?.amount ? String(state?.amount) : '',
                    tag: '',
                    number:
                        state && state?.num_repayment
                            ? String(state?.num_repayment)
                            : '',
                    fee_type: '',
                    date: '',
                }}
                validationSchema={Schema}
                enableReinitialize
                onSubmit={(values) => {
                    if (Number(values.amount) >= 5000) {
                        if (selectedUser) {
                            if (
                                selectedFee !== undefined &&
                                selectedFee !== null
                            ) {
                                if (selectedFee === 0) {
                                    values.fee_type = 'lip_ma'
                                }
                                if (values.fee_type.length > 0) {
                                    if (reallySelectedCard) {
                                        const data: IManagementBodyFirst = {
                                            moneyPool: params?.id,
                                            poolShip: selectedUser.id,
                                            amount: values.amount,
                                            tag: values.tag,
                                            number_of_repayments: values.number,
                                            bank_account:
                                                reallySelectedCard &&
                                                reallySelectedCard.id,
                                            bankName:
                                                reallySelectedCard &&
                                                reallySelectedCard.full_name +
                                                    '-' +
                                                    reallySelectedCard.bank_name,
                                            // carried for the confirmation
                                            // screen only — the API call
                                            // picks its fields by name
                                            bankAccount: reallySelectedCard,
                                            ctx_id: params && Number(params.id),
                                            receiver: selectedUser?.memberId,
                                            name:
                                                selectedUser &&
                                                selectedUser?.name,
                                            interest_pay_mode: values.fee_type,
                                            interest_type: selectedFeeType,
                                            interest_rate: selectedFee,
                                            pay_date:
                                                moment().format('YYYY-MM-DD'),
                                            fundName: state?.name,
                                            due_date:
                                                values.date.length > 0
                                                    ? values.date
                                                    : getOneMonthLater(),
                                            fixed_interest_amount:
                                                selectedFeeType === 'percentage'
                                                    ? 0
                                                    : selectedFee,
                                        }
                                        mutate(data)
                                    } else {
                                        toast.error('شماره حساب را انتخاب کنید')
                                    }
                                } else {
                                    toast.error(
                                        'نحوه دریافت کارمزد را انتخاب کنید'
                                    )
                                }
                            } else {
                                toast.error('میزان کارمزد را وارد کنید')
                            }
                        } else {
                            toast.error('دریافت کننده وام را انتخاب کنید')
                        }
                    } else {
                        toast.error('حداقل مبلغ وام پنج هزار تومان می باشد')
                    }
                }}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen text-sm ">
                            <div className=" grow-0">
                                <Header title="اعطای وام" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className="  bg-white  mt-14 rounded-lg relative py-4 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                    <div className=" text-center mt-4">
                                        <img
                                            src={AddNewIcon}
                                            alt="add-loan"
                                            className=" absolute right-[35%] md:right-[40%] lg:right-[40%] -top-14"
                                        />
                                        <p className=" mb-2">موجودی صندوق:</p>
                                        <p className=" text-black">
                                            {state &&
                                                Number(
                                                    state.exist
                                                ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                    <div className="  w-full text-center">
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            allowNegative={false}
                                            name="amount"
                                            placeholder="مبلغ وام (تومان)"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3  "
                                            value={values.amount}
                                            isGray
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />
                                        {values.amount !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    values.amount.toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}

                                        <div className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white">
                                            {selectedUser?.name
                                                ? selectedUser?.name
                                                : 'دریافت کننده وام'}
                                        </div>
                                        <div className=" w-full text-center">
                                            <Field
                                                type="number"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3  "
                                                name="number"
                                                placeholder="تعداد اقساط"
                                                min={0}
                                            />
                                            {errors.number &&
                                                touched.number && (
                                                    <p className=" text-sm text-error-3 text-center">
                                                        {errors.number}
                                                    </p>
                                                )}
                                        </div>
                                        <div
                                            onClick={() =>
                                                setIsOpenFeeModal(true)
                                            }
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {selectedFee !== undefined &&
                                            selectedFee !== null &&
                                            selectedFee !== 0
                                                ? `${selectedFee} ${
                                                      selectedFeeType ===
                                                      'percentage'
                                                          ? 'درصد'
                                                          : 'تومان'
                                                  }`
                                                : 'میزان کارمزد'}
                                        </div>
                                        {selectedFee !== 0 && (
                                            <Field
                                                name="fee_type"
                                                as="select"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            >
                                                <option className="text-gray-1">
                                                    نحوه دریافت کارمزد
                                                </option>
                                                <option value="lip_ma">
                                                    افزودن به هر قسط
                                                </option>
                                                <option value="lip_pr">
                                                    کسر از مبلغ وام
                                                </option>
                                            </Field>
                                        )}

                                        <div
                                            dir="rtl"
                                            className="border-b border-dashed border-gray-1"
                                        >
                                            <>
                                                <CustomDatePicker
                                                    setValue={(e: string) => {
                                                        setFieldValue('date', e)
                                                    }}
                                                    name={'date'}
                                                    title="تاریخ شروع اقساط (اختیاری)"
                                                    placeHolder="تاریخ شروع اقساط (اختیاری)"
                                                />
                                            </>
                                        </div>
                                        {/* The account the member chose when
                                            they filed the request. Its number
                                            is shown here, not only inside the
                                            picker: a manager who is going to
                                            hand the money over themselves
                                            needs to read it, and «فقط ثبت
                                            شود» is two screens further on. */}
                                        <div
                                            onClick={() => {
                                                selectedUser
                                                    ? setIsOpenWalletModal(true)
                                                    : toast.error(
                                                          'دریافت کننده را انتخاب کنید'
                                                      )
                                            }}
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {reallySelectedCard ? (
                                                <>
                                                    <span>
                                                        {reallySelectedCard.full_name +
                                                            '-' +
                                                            reallySelectedCard.bank_name}
                                                    </span>
                                                    {accountNumberOf(
                                                        reallySelectedCard
                                                    ) && (
                                                        <span
                                                            dir="ltr"
                                                            className=" mt-1 block text-black tracking-wide"
                                                        >
                                                            {formatAccountNumber(
                                                                accountNumberOf(
                                                                    reallySelectedCard
                                                                )!.value
                                                            )}
                                                        </span>
                                                    )}
                                                </>
                                            ) : (
                                                'شماره حساب'
                                            )}
                                        </div>
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات(اختیاری)"
                                        />
                                        {errors.tag && touched.tag && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.tag}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                            >
                                تایید
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={() => navigate(-1)}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <SelectModal
                show={isOpenReceiver}
                onHide={() => setIsOpenReceiver(false)}
                setSelectedUser={setSelectedUser}
                setMemberId={setMemberId}
            />
            <WithDrawWalletModal
                show={isOpenWalletModal}
                onHide={() => setIsOpenWalletModal(false)}
                data={!isLoading && data && data.receivers[0].bankaccounts}
                activeAccounts={activeAccounts}
                otherAccounts={otherAccounts}
                selectedUser={selectedUser?.name}
                setSelectedBankNumber={setSelectedBankNumber}
                handleSelectCard={handleSelectCard}
            />
            <FeeModal
                show={isOpenFeeModal}
                onHide={() => setIsOpenFeeModal(false)}
                setSelectedFee={setSelectedFee}
                setSelectedFeeType={setSelectedFeeType}
            />
        </>
    )
}
